/** Sample industry summary API payload — matches `getIndustrySummary` response data. */
export const SECTOR_INDUSTRY_OUTLOOK_TEST_PAYLOAD = {
  industryOutlook: {
    status: "success",
    generated_at: "2026-09-24T10:39:16.765665+00:00",
    cached: true,
    cache_expires_at: "2026-10-24T10:39:16.765681+00:00",
    "Sector Risk":
      "Medium — The sector is growing but faces margin pressure and moderate regulatory exposure.",
    "Market Size":
      "{'current': 'USD 155 Bn to USD 165 Bn', 'forecast_2030': 'USD 230 Bn to USD 255 Bn'}",
    "Industry CAGR": "8 to 9 percent",
    "Market Growth": "Projected to reach USD 300 Bn by 2030",
    overview: [
      "India's chemical market is currently valued between USD 155 Bn and USD 165 Bn.",
      "The market is projected to grow to USD 230 Bn to USD 255 Bn by 2030.",
      "CAGR for the chemical sector is estimated at 8 to 9 percent.",
      "The sector aims for a market size of USD 1 trillion by 2040.",
    ],
    sources: [
      {
        heading:
          "India's chemicals industry projected to reach up to US$ 255 billion ...",
        link: "https://www.ibef.org/news/india-s-chemicals-industry-projected-to-reach-up-to-us-255-billion-by-2030-mckinsey-report",
      },
      {
        heading: "[PDF] Leading India's chemical industry through global headwinds",
        link: "https://www.indianchemicalcouncil.com/docs/resources/From%20Challenges%20To%20Possibilities%20Leading%20Indias%20Chemical%20Industry%20Through%20Global%20Headwinds.pdf",
      },
      {
        heading: "How India can lead global chemical industry growth | McKinsey",
        link: "https://www.mckinsey.com/industries/chemicals/our-insights/from-challenges-to-possibilities-leading-indias-chemical-industry-through-global-headwinds",
      },
      {
        heading: "Building The Next Indian Chemical Giant | BCG",
        link: "https://www.bcg.com/publications/2026/india-building-the-next-indian-chemical-giant",
      },
    ],
    "Growth Drivers": [
      "Increased demand for petrochemicals in various industries.",
      "Government initiatives to boost manufacturing and exports.",
      "Investment in greenfield projects and infrastructure development.",
    ],
    "Key Risks": [
      "Regulatory changes may impact operational costs and compliance.",
      "Global market fluctuations can affect pricing and demand.",
      "Competition from international players may pressure margins.",
    ],
  },
  customerInfo: {
    entityName: "RELIANCE INDUSTRIES LIMITED",
    industry: "Chemicals",
    segment: "Petrochemicals",
  },
  fetchedAt: "2026-09-24T10:39:16.765665+00:00",
} as const;
